export { useAnonymousESBannerCopy } from './useAnonymousESBannerCopy.hook';
